import { render } from "./MainHome.vue?vue&type=template&id=6a956a68&scoped=true"
import script from "./MainHome.vue?vue&type=script&lang=js"
export * from "./MainHome.vue?vue&type=script&lang=js"

import "./MainHome.vue?vue&type=style&index=0&id=6a956a68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a956a68"]])

export default __exports__